import React from 'react'
import { useFormikContext } from 'formik'
import styled from 'styled-components'
import { _ } from 'utils'
import { $gray_100 } from 'utils/colors'
import { PerformerType } from 'generated/graphql'
import TextField from '../../forms/components/TextField'
import Editor from '../../forms/components/Editor'
import FileUpload, { PDF_PPT_ONLY } from '../../forms/components/FileUpload'
import MugShotField from '../../forms/components/MugShotField'

const S = {
    MugShotField: styled(MugShotField)`
        background: ${$gray_100};
        margin-left: -10px;
        margin-right: -10px;
        width: calc(100% + 20px);
        display: flex;
        padding: 12px;
  `
}

const AboutSpeaker = () => {
    const formContext = useFormikContext()
    const values = formContext.values as PerformerType

    return (
        <>
            <S.MugShotField
                name="mugshot"
                label={_('speaker.form.mugshot')}
                helperText={_('speaker.form.mugshot_help')}
            />
            <TextField
                name="name"
                isRequired
                label={_('speaker.form.name')}
                lg={1/2}
            />
            <TextField
                name="locationType"
                label={_('speaker.form.location_type')}
                helperText={_('speaker.form.location_type.helper_text')}
                showInfoIcon
                isDisabled
                lg={1/2}
            />
            <TextField
                name="jobtitle"
                label={_('speaker.form.jobtitle')}
                lg={1/2}
            />
            <TextField
                name="company"
                label={_('speaker.form.company')}
                lg={1/2}
            />
            <FileUpload
                name="attachment"
                dependField="attachmentName"
                label={_('speaker.form.attachment')}
                placeholder={_('speaker.form.attachment.placeholder')}
                maxSize={2}
                accept={PDF_PPT_ONLY}
                lg={1/2}
            />
            <TextField
                name="attachmentName"
                label={_('speaker.form.attachmentName')}
                placeholder={_('speaker.form.attachmentName.placeholder')}
                lg={1/2}
                isDisabled={!values.attachment}
            />
            <Editor name="about" label={_('speaker.form.about')} />
        </>
    )
}

export default AboutSpeaker
